import './loading-indicator.css';

export const LoadingIndicator = () => (
  <div className="typing-indicator" data-testid="loading-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
);
